import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1886e4e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1886e4e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886e4e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1886e4e2')) {
      api.createRecord('1886e4e2', component.options)
    } else {
      api.reload('1886e4e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1886e4e2&scoped=true", function () {
      api.rerender('1886e4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeKanban/index.vue"
export default component.exports